<template>
    <div ref="container">
      <a-modal :title="title" :width="1400" :visible="visible" :confirmLoading="confirmLoading" :getContainer="() => $refs.container" :maskStyle="{'top':'93px','left':'154px'}" :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:10%;height: 50%;">
        <template slot="footer">
          <a-button key="back" @click="handleCancel">
            关闭
          </a-button>
          <a-button type="primary" @click="handleOk">
            确认
          </a-button>
        </template>
        <div>
            <a-table
                ref="table"
                size="middle"
                bordered
                rowKey="id"
                :columns="columns"
                :dataSource="dataSource"
                :pagination="ipagination"
                :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange , type: 'radio', columnWidth:'3%'}" :scroll="{ x: 500 }" 
                :loading="loading" 
                @change="handleTableChange">
              </a-table>
        </div>
      </a-modal>
    </div>
  </template>
  <script>
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { getAllTemplates, bindTemplate, getProcess } from '@/api/api'
  import Vue from 'vue'
  export default {
    name: 'VendorModal',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
    },
    data() {
      return {
        title: '事件规则',
        visible: false,
        fileList: [],
        model: {},
        isReadOnly: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 18 },
        },
        confirmLoading: false,
        selectedRowKeys: [],
        columns:[
            {
              title: '序号',
              dataIndex: '',
              key:'rowIndex',
              width: '50px',
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            { title: '模版名称', dataIndex: 'templateName', width: 70, align: 'left' },
            { title: '模版ID', dataIndex: 'id', width: 70, align: 'left' }, // 添加规则ID列
        ],
        uuid: '',
        selectedId:'',
        getId : ''
      }
    },
    created() {},
    methods: {
      show(data){
        this.visible = true
        this.getId = data.id
        console.log(data,'传过来的数据==========')
        this.getRuleList()
        this.getBindTemplate()
      },
      // 获取所有规则列表
      async getRuleList(){
        const res = await getAllTemplates()
        if( res.code == 200 && res.success == true ){
          this.dataSource = res.result
        } else {
          this.$message.error(res.message)
        }
      },
      // 获取绑定的规则
      async getBindTemplate(){
        const res = await getProcess(this.getId)
        if( res.code == 200 && res.success == true ){
            console.log(res,'res===============')
          this.selectedRowKeys.push(res.result.formTemplateId)
        } else {
          this.$message.error(res.message)
        }
      },
      close() {
        this.$emit('close')
        this.visible = false
        this.selectedRowKeys = []
      },
      async handleOk() {
        const params = {
            id: this.getId,
            formTemplateId: this.selectedId
        }
        const res = await bindTemplate(params)
        if( res.code == 200 && res.success == true ){
            this.$message.success(res.result)
            this.close()
            // 绑定成功以后如何更新父组件table里面的codeRuleId的值
            this.$emit('update:traceTemplateId', this.selectedId)
            this.$emit('close'); // 触发关闭事件
            this.selectedRowKeys = []
        } else {
            this.$message.error(res.result)
        }
      },
      handleCancel() {
        this.close()
        this.selectedRowKeys = []
      },
    //   绑定事件规则
        handleTableChange(pagination, filters, sorter){
            console.log('Selected Row Keys:', this.selectedRowKeys);
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
            this.selectedId = selectedRowKeys[0]
            console.log('Selected 123:', this.selectedId);
        },
    },
  }
  </script>
  <style scoped>
  </style>